import { AuthService } from '../auth-service';
import { fetchUser } from '../fetch-user';

import { getLastWorkspaceId } from '@/entities/user/utils/last-workspace';
import { REDIRECT_PAGE } from '@/shared/redirect/redirect-constants';

type RedirectReturnPath =
  | {
      to: '/workspace/$workspaceId/campaigns/create';
      params: { workspaceId: string };
    }
  | {
      to: '/workspace/$workspaceId/create-new';
      params: { workspaceId: string };
    }
  | {
      to: '/workspace/$workspaceId';
      params: { workspaceId: string };
    }
  | {
      to: '/workspace/$workspaceId/settings/plan';
      params: { workspaceId: string };
    }
  | {
      to: '/workspace/create/name';
      search: {
        redirectPage: REDIRECT_PAGE | undefined;
      };
    };

export const getPageRoute = (id: string, pageName?: REDIRECT_PAGE): RedirectReturnPath => {
  switch (pageName) {
    case REDIRECT_PAGE.CREATE_NEW:
      return {
        to: `/workspace/$workspaceId/create-new`,
        params: { workspaceId: id },
      };
    case REDIRECT_PAGE.CREATE_CAMPAIGN:
      return {
        to: `/workspace/$workspaceId/campaigns/create`,
        params: { workspaceId: id },
      };
    case REDIRECT_PAGE.SETTINGS_PLAN:
      return {
        to: '/workspace/$workspaceId/settings/plan',
        params: { workspaceId: id },
      };
    default:
      return {
        to: '/workspace/$workspaceId',
        params: { workspaceId: id },
      };
  }
};

export async function getLoginRedirectPath(
  token?: string,
  pageName?: REDIRECT_PAGE,
): Promise<RedirectReturnPath> {
  const user = await fetchUser();
  if (user && token) {
    try {
      const { id } = await AuthService.validateInviteToken(token);
      return getPageRoute(id, pageName);
    } catch (e) {
      console.error('Invalid token. skipping this step');
      console.error(e);
    }
  }

  const lastWorkspaceId = getLastWorkspaceId(user.id);
  const isValidLastWorkspace = user.workspaces.find((w) => w.id === lastWorkspaceId);
  const firstWorkspaceId = user.workspaces[0]?.id;
  const targetWorkspaceId = isValidLastWorkspace ? lastWorkspaceId : firstWorkspaceId;

  if (targetWorkspaceId) {
    return getPageRoute(targetWorkspaceId, pageName);
  } else {
    return {
      to: '/workspace/create/name',
      search: { redirectPage: pageName },
    };
  }
}
